module.exports = __webpack_public_path__ + "static/media/banner_trailblazers.bc9c6e23.jpg";